export const MFA_SETUP_PATH = "/mfa/setup";
export const MFA_VERIFY_PATH = "/mfa/verify";

export const MFA_TRUSTED_TOKEN_KEY = "gobo_mfa_trusted_token";

export const TRUSTED_DEVICE_DAYS = 30;

export const FAKE_REST_MFA_ENROLLED_KEY = "fakerest_mfa_enrolled";
export const FAKE_REST_MFA_TRUSTED_KEY = "fakerest_mfa_trusted";

export function isMfaPath(pathname: string): boolean {
  return (
    pathname === MFA_SETUP_PATH ||
    pathname === MFA_VERIFY_PATH ||
    pathname.includes(MFA_SETUP_PATH) ||
    pathname.includes(MFA_VERIFY_PATH)
  );
}

export function isDemoMode(): boolean {
  return import.meta.env.VITE_IS_DEMO === "true";
}
